import React, {useContext, useEffect, useState} from "react";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
// @ts-ignore
import {Link, useParams} from "react-router-dom";

import Constants from "../../../data/Constants";
import {RowDivF1} from "../../styledComponents/CustomStyledComponents";
import Colors from "../../../assets/colors/Colors";
import '../CountryStyles.css'
import { useTranslation } from "react-i18next";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import { formatNumber } from "../../../services/helpers";

interface InfoBoxInterface {
    showLinkButton?: boolean,
    customStyle?: object,
    countryInfo?: any,
    allDataLoaded: boolean
}

const SkeletonLine: React.FC<{count: number, width: number}> = ({count, width}) => {
    return (
        <SkeletonTheme
            color={Colors.loader}
            highlightColor={Colors.loaderHighlight}
        >
            <div style={{ maxWidth: width }}>
                <Skeleton count={count} width={width}/>
            </div>
        </SkeletonTheme>
    )
};

const InfoBox: React.FC<InfoBoxInterface> = ({showLinkButton = false, customStyle = {}, countryInfo, allDataLoaded}) => {
    const { t, i18n } = useTranslation();

    let { countryCode } = useParams();
    const graphicsUrl = Constants.routes.rankingsCountryGraphics.replace(':countryCode', countryCode);

    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';
    const lng = getCurrentLng() === 'es' ? 'de' : getCurrentLng();

    const info = [
        {label: t('countryContainer.infoBox.tier'), value: countryInfo.tier || '-' },
        {label: t('countryContainer.infoBox.type'), value: t(`groups.${countryInfo.group}`) },
        {label: t('countryContainer.infoBox.gip'), value: formatNumber(parseFloat(countryInfo.gip), 2, lng)},
        {label: t('countryContainer.infoBox.ranking'), value: countryInfo.gip_ranking},
        {label: t('countryContainer.infoBox.gai'), value: formatNumber(parseFloat(countryInfo.gai), 2, lng)},
        {label: t('countryContainer.infoBox.rankingGai'), value: countryInfo.gai_ranking}
    ];

    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;

    return (
        <div style={{border: `3px solid ${color}`, display: "flex", flexDirection: "column",  marginBottom: 20, ...customStyle}}>
            <RowDivF1 className='infoBoxTitle'>
                <div>{t('countryContainer.infoBox.title')}</div>
            </RowDivF1>
            { info && info.map((element: any, index: any) => (
                <div className='ieFlex' key={ index }>
                    <RowDivF1 className='infoRowWrapper'>
                        <div className='rowLabel'>
                            {element.label}:
                        </div>
                        <div className='rowValue' style={{color: color}}>
                            {
                                allDataLoaded ?
                                    element.value
                                    : <SkeletonLine count={1} width={200}/>
                            }
                        </div>
                    </RowDivF1>
                </div>
            ))}
            {
                showLinkButton &&
                <div className='ieFlex'>
                    <RowDivF1 className='buttonWrapper'>
                      <Link
                          style={{paddingTop: 9, paddingBottom: 12, paddingLeft: 50, color: Colors.fontGray}}
                          to={graphicsUrl}
                      >
                        {t('countryContainer.infoBox.graphics')}
                      </Link>
                    </RowDivF1>
                </div>
            }
        </div>
    )
};

export default InfoBox;
